(function () {
  "use strict";
  var WIDGET_HTML="<div class=\"cw-vin__sep\"><span>or by</span></div>\n<label class=\"cw-vin__label\" for=\"cw-vin-input\">VIN or JDM frame number</label>\n  <div class=\"cw-vin__row\">\n    <input id=\"cw-vin-input\" class=\"cw-vin__input\" type=\"text\"\n           placeholder=\"e.g. HZJ79-0001234  or  JT3HJ85J0X0123456\"\n           autocomplete=\"off\" autocapitalize=\"characters\" spellcheck=\"false\" />\n    <button id=\"cw-vin-btn\" class=\"cw-vin__btn\" type=\"button\">Decode</button>\n  </div>\n  <div id=\"cw-vin-status\" class=\"cw-vin__status\" role=\"status\" aria-live=\"polite\"></div>\n  <div id=\"cw-vin-choices\" class=\"cw-vin__choices\" hidden></div>\n  <div id=\"cw-vin-current\" class=\"cw-vin__current\" hidden></div>";
  var WIDGET_CSS=".cw-vin{font:inherit;max-width:580px;margin:0 0 1rem}\n  .cw-vin__label{display:block;font-weight:600;margin-bottom:.4rem;font-size:.95rem}\n  .cw-vin__row{display:flex;gap:.5rem;flex-wrap:wrap}\n  .cw-vin__input{flex:1 1 240px;min-width:0;padding:.6rem .7rem;border:1px solid #c9c9c9;border-radius:6px;font-size:1rem;text-transform:uppercase}\n  .cw-vin__btn{padding:.6rem 1.1rem;border:0;border-radius:6px;background:#111;color:#fff;font-size:1rem;font-weight:600;cursor:pointer}\n  .cw-vin__btn:disabled{opacity:.55;cursor:default}\n  .cw-vin__status{margin-top:.5rem;font-size:.9rem;min-height:1.1em}\n  .cw-vin__status.is-ok{color:#1a7f37}\n  .cw-vin__status.is-warn{color:#9a6700}\n  .cw-vin__status.is-err{color:#c0392b}\n  .cw-vin__choices{margin-top:.6rem;border:1px solid #e2c08d;background:#fff8e8;border-radius:6px;padding:.6rem .7rem}\n  .cw-vin__choices p{margin:0 0 .45rem;font-size:.9rem;font-weight:600}\n  .cw-vin__choice{display:block;font-size:.92rem;padding:.25rem 0;cursor:pointer}\n  .cw-vin__choice input{margin-right:.5rem}\n  .cw-vin__go{margin-top:.5rem;padding:.45rem .9rem;border:0;border-radius:5px;background:#111;color:#fff;cursor:pointer;font-size:.9rem}\n  .cw-vin__current{margin-top:.6rem;font-size:.9rem;background:#f4f4f4;border:1px solid #e2e2e2;border-radius:6px;padding:.6rem .7rem}\n  .cw-vin__cv-main{display:flex;align-items:center;gap:.6rem;flex-wrap:wrap}\n  .cw-vin__current b{font-weight:600}\n  .cw-vin__clear{margin-left:auto;background:none;border:0;color:#c0392b;cursor:pointer;text-decoration:underline;font-size:.85rem;padding:0}\n  .cw-vin__by{margin-top:.5rem;display:flex;align-items:center;gap:.4rem;flex-wrap:wrap;font-size:.88rem}\n  .cw-vin__by input{width:7em;padding:.35rem .5rem;border:1px solid #c9c9c9;border-radius:5px;font-size:.88rem}\n  .cw-vin__by button{padding:.35rem .7rem;border:0;border-radius:5px;background:#444;color:#fff;cursor:pointer;font-size:.85rem}\n  .cw-vin__note{margin-top:.5rem;font-size:.85rem;color:#555;border-top:1px dashed #d8d8d8;padding-top:.45rem}\n  .cw-vin__note a{color:#1a5fb4}\n  .cw-vin__ext{display:inline-block;margin-top:.4rem;font-size:.85rem}\n.cw-vin--inbox{max-width:100%;margin:.2rem 0 0}\n.cw-vin__sep{display:none;align-items:center;text-align:center;color:#777;font-size:.78rem;text-transform:uppercase;letter-spacing:.09em;margin:.95rem 0 .7rem}\n.cw-vin--inbox .cw-vin__sep{display:flex}\n.cw-vin__sep::before,.cw-vin__sep::after{content:\"\";flex:1;height:1px;background:#dcdcdc}\n.cw-vin__sep span{padding:0 .8rem;font-weight:700}";


  /* ===================== CONFIG ===================== */
  var CONFIG = {
    fieldYear:  "dropdown-field_1",   // Year select (falls back to content match)
    // The YMM Make/Model selects are EMPTY on the fresh landing page and change
    // ids by page state, so we never target the Model select by id. The widget
    // matches the typed chassis against CATALOG_MODELS (below), unioned with any
    // live md_ options it can find, then searches via rq.
    resultPage: "/pages/product-result",
    storageKey: "cw_active_vehicle",
    rqJoiner:   "__",
    nhtsaBase:  "https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/",
    yearMin: 1981, yearMax: 2021,            // YMM Year dropdown range
    buildYearMin: 1960, buildYearMax: 2026,  // accepted build-year range

    // Series where model-year running changes matter. Matched against the
    // model option VALUE (slugs contain e.g. "70-series"). Triggers a coarse
    // "contact us to confirm" note rather than auto-resolving crossover builds.
    yearSensitiveTokens: ["70-series"],
    contactUrl: "/pages/contact",         // <-- verify your Contact page URL

    // Public, well-documented generational breaks. Keyed by a token found in
    // the model option VALUE. Used (only once a build year is known) to show an
    // approximate generation and to flag boundary-year builds for confirmation.
    // Sources: Wikipedia (Toyota Land Cruiser J70), CarBuzz, Silodrome. Edit
    // freely — these are facts, not magic.
    GENERATIONS: {
      "70-series": {
        // BODY / styling generations only — engine is already encoded in the
        // chassis code (HZJ=1HZ, FZJ=1FZ-FE, VDJ=V8), so buckets are NOT tied to
        // engine. The HZJ79 runs to the present and shares the VDJ79 body, so
        // within one chassis code the build year is the only thing separating a
        // narrow-front (1999-2006) truck from a wide-front (2007+) truck.
        // Phased-out early codes (BJ70 etc.) simply fall into the pre-1999 bucket.
        buckets: [
          { from:1984, to:1998, label:"Pre-1999 early 70-series" },
          { from:1999, to:2006, label:"1999\u20132006 \u2014 narrow front, pre-2007 styling/dash" },
          { from:2007, to:2100, label:"2007+ \u2014 wide front, integrated fenders, updated dash" }
        ],
        minorChangeYears: [2009, 2012, 2016, 2023]   // running changes -> also flagged
      }
    },

    // Full catalog Model slugs (captured live 2026-06-11). Used to match the
    // typed chassis when the live dropdown is empty/partial. To refresh after
    // adding models: open /pages/product-result?rq=mk_toyota and copy the md_
    // option values. The widget also unions in any live md_ options it finds,
    // so brand-new models still match before you update this list.
    CATALOG_MODELS: [
      "md_hilux-kdn145-1kd-ftv","md_hilux-kdn150-1kd-ftv","md_hilux-kdn165-1kd-ftv","md_hilux-kdn170-1kd-ftv",
      "md_hilux-ln106-ln107-ln109-2lt-e-3l","md_hilux-ln109-3l",
      "md_hilux-surf-4runner-kzn130-1kz-te","md_hilux-surf-4runner-kzn185-1kz-te","md_hilux-surf-4runner-rzn185-3rz-e",
      "md_hilux-surf-4runner-vzn130-3vz-e","md_hilux-surf-4runner-vzn185-5vz-fe","md_hilux-surf-kdn185-1kd-ftv",
      "md_hilux-surf-ln130-2lt-e","md_hilux-surf-rzn18x-3rz-e","md_hilux-yn106-yn107-22r-e","md_hilux-yn107-22r-e",
      "md_land-cruiser-bj60-60-series-3b","md_land-cruiser-bj61-60-series-13bt","md_land-cruiser-bj70-70-series-3b",
      "md_land-cruiser-bj74-70-series-3b","md_land-cruiser-fj60-60-series-3f","md_land-cruiser-fj62-60-series-3f-e",
      "md_land-cruiser-fj75-70-series-3f","md_land-cruiser-fj80-80-series-3f-e","md_land-cruiser-fzj71-70-series-1fz-fe",
      "md_land-cruiser-fzj76-70-series-1fz-fe","md_land-cruiser-fzj79-70-series-1fz-fe","md_land-cruiser-fzj80-80-series-1fz-fe",
      "md_land-cruiser-grj71-70-series-1gr-fe","md_land-cruiser-grj76-70-series-1gr-fe","md_land-cruiser-grj78-70-series-1gr-fe",
      "md_land-cruiser-grj79-70-series-1gr-fe","md_land-cruiser-hdj100-100-series-1hd-fte","md_land-cruiser-hdj81-80-series-1hd-t",
      "md_land-cruiser-hj60-60-series-2h","md_land-cruiser-hj61-60-series-12h-t","md_land-cruiser-hzj70-70-series-1hz",
      "md_land-cruiser-hzj71-70-series-1hz","md_land-cruiser-hzj73-70-series-1hz","md_land-cruiser-hzj74-70-series-1hz",
      "md_land-cruiser-hzj75-70-series-1hz","md_land-cruiser-hzj76-70-series-1hz","md_land-cruiser-hzj77-70-series-1hz",
      "md_land-cruiser-hzj78-70-series-1hz","md_land-cruiser-hzj79-70-series-1hz","md_land-cruiser-hzj80-80-series-1hz",
      "md_land-cruiser-hzj81-80-series-1hz","md_land-cruiser-prado-kdj95-1kd-ftv","md_land-cruiser-prado-kzj71-1kz-te",
      "md_land-cruiser-prado-kzj95-1kz-te","md_land-cruiser-prado-lj70-2lt","md_land-cruiser-prado-lj71-2lt-e",
      "md_land-cruiser-prado-lj78-2lt-e","md_land-cruiser-pzj70-70-series-1pz","md_land-cruiser-pzj77-70-series-1pz",
      "md_land-cruiser-vdj200-200-series-1vd-ftv","md_land-cruiser-vdj76-70-series-1vd-ftv",
      "md_land-cruiser-vdj78-70-series-1vd-ftv","md_land-cruiser-vdj79-70-series-1vd-ftv"
    ],

    // DORMANT build-date decode hook. Leave disabled until you have a licensed
    // JDM/EPC feed behind a Shopify App Proxy (keeps any API key server-side).
    // The proxy should accept ?frame=XXX and return JSON {year, month}.
    buildDateApi: { enabled: false, proxyUrl: "/apps/cw-decode" },

    // Optional customer-facing "find your build date" EPC deep-link (frames).
    // VERIFY the URL/format works before enabling — left off by default.
    offerEpcLookup: false,
    epcLookupBase: "https://www.toyodiy.com/parts/q?vin=",   // frame, hyphen removed

    // Optional PartsFan deep-link for out-of-catalog frames (customer passes
    // the human check on PartsFan's own page).
    offerPartsFanLink: true,
    partsFanBase: "https://partsfan.com/vinchk/all/",

    debug: true
  };
  /* ================================================== */

  function log(){ if(CONFIG.debug && window.console) console.info.apply(console,["[cw-vin]"].concat([].slice.call(arguments))); }
  var els = {};
  function el(id){ return document.getElementById(id); }

  /* ---------- input / decode ---------- */
  function normalize(raw){ return (raw==null?"":String(raw)).trim().toUpperCase().replace(/\s+/g,""); }
  function isVin(s){ return /^[A-HJ-NPR-Z0-9]{17}$/.test(s) && s.indexOf("-")===-1; }
  function clampYmmYear(y){ var n=parseInt(y,10); return (isNaN(n)||n<CONFIG.yearMin||n>CONFIG.yearMax)?"":String(n); }
  function frameChassis(s){ return s.split("-")[0].toLowerCase().replace(/[^a-z0-9]/g,""); }
  function seriesTokens(model, year){
    var y=parseInt(year,10), s=null;
    if(y>=2008)s="200"; else if(y>=1998)s="100"; else if(y>=1991)s="80"; else if(y>=1981)s="60";
    var t=[]; var lower=(model||"").toLowerCase().replace(/\s+/g,"-"); if(lower)t.push(lower);
    if(s)t.push(s+"-series"); return t;
  }

  function decodeFrame(s){
    var chassis=frameChassis(s);
    return { source:"frame", input:s, chassis:chassis,
             makeValue:"mk_toyota", makeLabel:"Toyota",
             modelTokens:[chassis], modelLabel:"chassis "+s.split("-")[0],
             buildYear:"", buildMonth:"" };
  }
  function decodeVin(vin){
    return fetch(CONFIG.nhtsaBase+encodeURIComponent(vin)+"?format=json")
      .then(function(r){return r.json();})
      .then(function(d){
        var r=(d&&d.Results&&d.Results[0])||{};
        var year=r.ModelYear||"", make=r.Make||"", model=r.Model||"";
        if(!year&&!make&&!model) return null;
        var lex=/lexus/i.test(make);
        return { source:"nhtsa", input:vin,
                 makeValue:lex?"mk_lexus":"mk_toyota", makeLabel:lex?"Lexus":(make||"Toyota"),
                 modelTokens:seriesTokens(model,year), modelLabel:model||"",
                 buildYear:year?String(year):"", buildMonth:"" };   // VIN gives exact model year
      })
      .catch(function(e){ log("NHTSA failed",e); return null; });
  }

  /* ---------- DORMANT build-date decode hook ----------
     Returns Promise<{year, month}|null>. Disabled => resolves null and the
     customer enters the build year by hand. Enable + point proxyUrl at your
     licensed feed to auto-fill. */
  function decodeBuildDate(frame){
    if(!CONFIG.buildDateApi.enabled) return Promise.resolve(null);
    return fetch(CONFIG.buildDateApi.proxyUrl+"?frame="+encodeURIComponent(frame))
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){ return (d && d.year) ? {year:String(d.year), month:d.month?String(d.month):""} : null; })
      .catch(function(){ return null; });
  }

  /* ---------- model matching (catalog list + any live options) ----------
     Make/Model selects are empty on the landing page and change ids by state,
     so we match against CATALOG_MODELS unioned with any live md_ options. */
  function slugLabel(v){ return v.replace(/^md_/,"").replace(/-/g," ").replace(/\b\w/g,function(c){return c.toUpperCase();}); }
  function allModelOptions(){
    var map={};
    document.querySelectorAll("select").forEach(function(s){
      Array.prototype.slice.call(s.options).forEach(function(o){
        if(/^md_/.test(o.value)) map[o.value]=(o.textContent||"").trim()||slugLabel(o.value);
      });
    });
    (CONFIG.CATALOG_MODELS||[]).forEach(function(v){ if(!map[v]) map[v]=slugLabel(v); });
    return Object.keys(map).map(function(v){ return {value:v, text:map[v]}; });
  }
  function matchModels(tokens){
    var opts=allModelOptions(), seen={}, out=[];
    opts.forEach(function(o){
      var val=o.value.toLowerCase(), txt=(o.text||"").toLowerCase();
      for(var i=0;i<tokens.length;i++){ var t=tokens[i];
        if(t&&(val.indexOf(t)!==-1||txt.indexOf(t)!==-1)&&!seen[o.value]){ seen[o.value]=1; out.push(o); break; } }
    });
    return out;
  }
  function yearSelect(){
    var byId=el(CONFIG.fieldYear); if(byId&&byId.tagName==="SELECT") return byId;
    var found=null;
    document.querySelectorAll("select").forEach(function(s){
      if(found) return;
      if(Array.prototype.slice.call(s.options).some(function(o){return /^yr_\d/.test(o.value);})) found=s;
    });
    return found;
  }
  function setYmmYear(year){
    var cy=clampYmmYear(year); if(!cy) return;
    var sel=yearSelect(); if(!sel) return;
    var opt=Array.prototype.slice.call(sel.options).filter(function(o){return o.value==="yr_"+cy;})[0];
    if(opt){ sel.value=opt.value; sel.dispatchEvent(new Event("change",{bubbles:true})); }
  }

  /* ---------- search via rq ---------- */
  function buildRq(v){
    var parts=[];
    var cy=clampYmmYear(v.buildYear);
    if(cy) parts.push("yr_"+cy);             // include only if a real, in-range year exists
    if(v.makeValue) parts.push(v.makeValue);
    if(v.modelValue) parts.push(v.modelValue);
    return parts.join(CONFIG.rqJoiner);
  }
  function goSearch(v){
    var rq=buildRq(v); if(!rq) return;
    var url=CONFIG.resultPage+"?rq="+rq;
    if(location.pathname+location.search===url){ log("already on target"); return; }
    window.location.assign(url);
  }

  /* ---------- storage ---------- */
  function save(v){ try{ localStorage.setItem(CONFIG.storageKey,JSON.stringify(v)); }catch(e){} }
  function load(){ try{ return JSON.parse(localStorage.getItem(CONFIG.storageKey)||"null"); }catch(e){ return null; } }
  function clear(){ try{ localStorage.removeItem(CONFIG.storageKey); }catch(e){} }

  /* ---------- helpers ---------- */
  function esc(s){ return String(s).replace(/[&<>"']/g,function(m){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[m];}); }
  function displayYear(v){ return v.buildYear ? ((v.buildMonth?v.buildMonth+"/":"")+v.buildYear) : ""; }
  function vehLabel(v){ return [v.buildYear, v.makeLabel, v.modelLabel].filter(Boolean).join(" "); }
  function status(msg,kind){ els.status.textContent=msg||""; els.status.className="cw-vin__status"+(kind?" is-"+kind:""); }
  function clearChoices(){ els.choices.hidden=true; els.choices.innerHTML=""; }
  function isYearSensitive(v){
    var val=(v.modelValue||"").toLowerCase();
    return CONFIG.yearSensitiveTokens.some(function(t){ return val.indexOf(t)!==-1; });
  }
  // Approximate generation from build year + which series the matched model is.
  // Returns {label, atBoundary} or null (no build year / unmapped series).
  function generationFor(v){
    var val=(v.modelValue||"").toLowerCase();
    var key=Object.keys(CONFIG.GENERATIONS).filter(function(k){ return val.indexOf(k)!==-1; })[0];
    if(!key || !v.buildYear) return null;
    var set=CONFIG.GENERATIONS[key], y=parseInt(v.buildYear,10);
    if(isNaN(y)) return null;
    var bucket=set.buckets.filter(function(b){ return y>=b.from && y<=b.to; })[0];
    var boundary=set.buckets.some(function(b){ return y===b.from || y===(b.from-1); }) ||
                 (set.minorChangeYears||[]).indexOf(y)!==-1;
    return { label: bucket?bucket.label:"", atBoundary: boundary };
  }
  function parseBuildDate(str){
    str=(str||"").trim();
    var m=str.match(/^(\d{1,2})[\/\-.](\d{4})$/);            // MM/YYYY
    if(m) return {month:String(parseInt(m[1],10)), year:m[2]};
    m=str.match(/^(\d{4})[\/\-.](\d{1,2})$/);                // YYYY-MM
    if(m) return {month:String(parseInt(m[2],10)), year:m[1]};
    m=str.match(/^(\d{4})$/);                                // YYYY
    if(m) return {month:"", year:m[1]};
    return null;
  }

  /* ---------- current-vehicle banner (with build-year capture) ---------- */
  function renderCurrent(v){
    if(!v){ els.current.hidden=true; els.current.innerHTML=""; return; }
    els.current.hidden=false;

    var h='<div class="cw-vin__cv-main"><span>Current vehicle: <b>'+esc(vehLabel(v))+'</b></span>'+
          '<button type="button" class="cw-vin__clear" id="cw-vin-clear">Clear</button></div>';

    if(v.modelValue){
      if(v.buildYear){
        h+='<div class="cw-vin__by">Build date: <b>'+esc(displayYear(v))+'</b> '+
           '<button type="button" id="cw-vin-by-edit">Edit</button></div>';
      } else {
        h+='<div class="cw-vin__by"><label for="cw-vin-by-input">Build date (from your build plate):</label>'+
           '<input id="cw-vin-by-input" type="text" placeholder="MM/YYYY or YYYY" inputmode="numeric"/>'+
           '<button type="button" id="cw-vin-by-save">Save</button></div>';
        if(CONFIG.offerEpcLookup && v.source==="frame" && v.input.indexOf("-")!==-1){
          h+='<a class="cw-vin__ext" href="'+esc(CONFIG.epcLookupBase+encodeURIComponent(v.input.replace("-","")))+
             '" target="_blank" rel="noopener">Not sure? Find your build date \u2192</a>';
        }
      }
      var gen=generationFor(v);
      if(gen && gen.label){
        h+='<div class="cw-vin__note">Likely generation: <b>'+esc(gen.label)+'</b> (approximate)'+
           (gen.atBoundary
              ? '. Your build year sits near a model-year change \u2014 <a href="'+esc(CONFIG.contactUrl)+'">contact us</a> to confirm fitment.'
              : '.')+'</div>';
      } else if(isYearSensitive(v)){
        h+='<div class="cw-vin__note">This series had running changes across model years. '+
           'Add your build date above, or <a href="'+esc(CONFIG.contactUrl)+'">contact us</a> to confirm fitment.</div>';
      }
    }
    els.current.innerHTML=h;

    var c=el("cw-vin-clear");
    if(c) c.addEventListener("click",function(){ clear(); renderCurrent(null); clearChoices(); status("Vehicle cleared."); els.input.value=""; });
    var ed=el("cw-vin-by-edit");
    if(ed) ed.addEventListener("click",function(){ v.buildYear=""; v.buildMonth=""; save(v); renderCurrent(v); });
    var sv=el("cw-vin-by-save");
    if(sv) sv.addEventListener("click",function(){
      var parsed=parseBuildDate(el("cw-vin-by-input").value);
      if(!parsed){ status("Enter the build date as MM/YYYY or just the year.","warn"); return; }
      var yr=parseInt(parsed.year,10);
      if(yr<CONFIG.buildYearMin||yr>CONFIG.buildYearMax){ status("That build year looks out of range.","warn"); return; }
      v.buildYear=parsed.year; v.buildMonth=parsed.month;
      save(v); setYmmYear(v.buildYear); renderCurrent(v);
      status("Build date saved: "+displayYear(v),"ok");
    });
  }

  /* ---------- model chooser (ambiguous match) ---------- */
  function renderChoices(v,choices){
    els.choices.hidden=false;
    var h="<p>More than one model matches that chassis \u2014 please confirm:</p>";
    choices.forEach(function(c,i){ h+='<label class="cw-vin__choice"><input type="radio" name="cw-mc" value="'+esc(c.value)+'"'+(i===0?" checked":"")+">"+esc(c.text)+"</label>"; });
    h+='<button type="button" class="cw-vin__go" id="cw-vin-go">Use this &amp; search</button>';
    els.choices.innerHTML=h;
    el("cw-vin-go").addEventListener("click",function(){
      var p=els.choices.querySelector('input[name="cw-mc"]:checked'); if(!p) return;
      v.modelValue=p.value;
      var ch=choices.filter(function(c){return c.value===p.value;})[0];
      v.modelLabel=ch?ch.text:v.modelLabel;
      clearChoices(); finalizeMatch(v);
    });
  }

  /* ---------- finalize a confirmed model: build-date hook -> save -> search ---------- */
  function finalizeMatch(v){
    decodeBuildDate(v.input).then(function(bd){
      if(bd && bd.year && !v.buildYear){ v.buildYear=bd.year; v.buildMonth=bd.month||""; }
      save(v); renderCurrent(v);
      status("Match found: "+vehLabel(v)+" \u2014 searching\u2026","ok");
      goSearch(v);
    });
  }

  /* ---------- main ---------- */
  function partsFanLink(v){
    if(!CONFIG.offerPartsFanLink || v.source!=="frame" || v.input.indexOf("-")===-1) return "";
    return '<a class="cw-vin__ext" href="'+esc(CONFIG.partsFanBase+encodeURIComponent(v.input))+
           '" target="_blank" rel="noopener">Look up full vehicle details on PartsFan \u2192</a>';
  }
  function onResult(v){
    save(v);
    var matches=matchModels(v.modelTokens||[]);
    if(matches.length===1){
      v.modelValue=matches[0].value; v.modelLabel=matches[0].text;
      finalizeMatch(v);
    } else if(matches.length>1){
      renderCurrent(v);
      status("Decoded "+vehLabel(v)+" \u2014 confirm the exact model below.","warn");
      renderChoices(v,matches);
    } else {
      renderCurrent(v);
      var extra=partsFanLink(v);
      status("Decoded "+vehLabel(v)+", but that model isn't in the catalog yet \u2014 pick the closest from the Model menu"+(extra?", or:":"."),"warn");
      if(extra){ els.choices.hidden=false; els.choices.innerHTML=extra; }
    }
  }
  function handleDecode(){
    clearChoices();
    var s=normalize(els.input.value);
    if(!s){ status("Enter a VIN or frame number.","warn"); return; }
    els.btn.disabled=true; status("Decoding\u2026");
    (isVin(s)?decodeVin(s):Promise.resolve(decodeFrame(s))).then(function(v){
      if(!v){ status("Couldn't decode that \u2014 double-check the number.","err"); return; }
      onResult(v);
    }).catch(function(e){ log(e); status("Something went wrong while decoding.","err"); })
      .then(function(){ els.btn.disabled=false; });
  }
  function rehydrate(){
    var v=load(); if(!v) return;
    renderCurrent(v); els.input.value=v.input||"";
    // rq is already in the URL after a search, so the page has restored the
    // dropdowns + results on its own; we only restore the banner + input.
  }
  function placeWidget(root){
    var box=document.getElementById("ymm_searchbox");
    if(box){
      if(root.parentNode!==box) box.appendChild(root);
      root.className="cw-vin cw-vin--inbox";
      var os=root.__cwOrigSection;
      if(os && !os.contains(box)) os.style.display="none";
    } else {
      root.className="cw-vin";
    }
  }
  function setupBoxGuard(root){
    if(root.__cwGuard) return; root.__cwGuard=true;
    try{
      var target=document.querySelector(".ymm_app")||document.body;
      var mo=new MutationObserver(function(){
        var box=document.getElementById("ymm_searchbox");
        if(box && root.parentNode!==box) placeWidget(root);
      });
      mo.observe(target,{childList:true,subtree:true});
    }catch(e){}
  }
  function init(){
    var root=el("cw-vin-decoder");
    if(!root) return;
    if(!document.getElementById("cw-vin-style")){ var st=document.createElement("style"); st.id="cw-vin-style"; st.textContent=WIDGET_CSS; document.head.appendChild(st); }
    if(!el("cw-vin-input")) root.innerHTML=WIDGET_HTML;
    if(!root.__cwOrigSection) root.__cwOrigSection=(root.closest?root.closest(".shopify-section"):null);
    placeWidget(root);
    setupBoxGuard(root);
    els.input=el("cw-vin-input"); els.btn=el("cw-vin-btn");
    els.status=el("cw-vin-status"); els.choices=el("cw-vin-choices"); els.current=el("cw-vin-current");
    if(!els.input||!els.btn) return;
    els.btn.addEventListener("click",handleDecode);
    els.input.addEventListener("keydown",function(e){ if(e.key==="Enter"){ e.preventDefault(); handleDecode(); } });
    rehydrate(); log("ready");
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",init); else init();
})();